import Vue from 'vue'
import axios from '@axios'

// Реактивное состояние колокольчика напоминалок: список для дропдауна и строка
// бэджа ('' скрывает бэдж, как у suggestionBadge).
export const gameReminders = Vue.observable({ items: [], count: '' })

// Обновляет список напоминалок. Ошибки глотаем: колокольчик не критичен.
export const refreshGameReminders = () => axios
    .get('/game-reminders')
    .then(response => {
        const items = response.data.data || []
        gameReminders.items = items
        gameReminders.count = items.length > 0 ? String(items.length) : ''
    })
    .catch(() => {})
